import React from 'react';
import { bool, shape, string } from 'prop-types';

const Undo = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1992 9.375C10.2117 9.375 8.41172 10.1175 7.02422 11.325L4.32422 8.625V15.375H11.0742L8.35922 12.66C9.40172 11.79 10.7292 11.25 12.1992 11.25C14.8542 11.25 17.1117 12.9825 17.8992 15.375L19.6767 14.79C18.6342 11.6475 15.6867 9.375 12.1992 9.375Z" fill="currentColor" />
  </svg>
);

Undo.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Undo;
